import AppError from './models/common/res/AppError';
import { request } from './request';
import { ChatRequestBody } from './models/chat-request/req/ChatRequestBody';

export const requestChat = async (body: ChatRequestBody) => {
  const url = `/v2/consultation/chat-request`;
  try {
    await request({
      method: 'post',
      url,
      requestBody: body,
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};

export const isValidChatRequest = async (chatLogId: number | string) => {
  const url = `/v2/consultation/verify-chat-request`;
  try {
    await request({
      method: 'get',
      url,
      queryParams: {
        chatLogId,
      },
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};
